<span class="custom-odds-value-style" *ngIf="shouldUseCustomStyle; else normal">{{ value }}</span>
<ng-template #normal>{{ value }}</ng-template>
